import { __decorate, __metadata } from "tslib";
import { DOCUMENT } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { ServiceWorkerInitializerProvider } from '@ho/libs/shared/initializers/service-worker.initializer';
import { deviceInitializerProvider } from '@ho/libs/shared/initializers/device.initializer';
import { translationsInitializerProvider } from '@ho/libs/shared/initializers/translations.initializer';
import { CoreDataAccessModule } from '@ho/shared/data-access/core-data-access';
import { AppEnvironment } from '@ho/shared/data-access/core/app-environment.model';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { MissingTranslationService, TranslateLoaderFactory, } from '@ho/shared/helpers/translate-loader-factory';
import { ConfirmModalModule } from '@ho/shared/ui/confirm-modal';
import { MissingTranslationHandler, TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { environment } from '../environments/environment';
import { AppComponent } from './app.component';
import { GuestUserGuard } from '@ho/shared/data-access/core/lib/guards/guest-user.guard';
// import { SentryErrorHandler } from '@ho/shared/data-access/core/lib/services/sentry.service';
import { DataAccessUiSettingsModule } from '@ho/shared/data-access/ui-settings';
import { customAppConfigInitializerProvider } from '@ho/libs/shared/initializers/custom-app-config.initializer';
import { uiSettingsInitializerProvider } from '@ho/libs/shared/initializers/ui-settings.initializer';
import { GridStateAccessModule } from '@ad/shared/data-access/grid-state';
export const appRoutes = [
    { path: '', redirectTo: 'a', pathMatch: 'full' },
    {
        path: 'a',
        canActivate: [GuestUserGuard],
        loadChildren: () => import('@ho/auth/feature-shell').then((m) => m.AuthFeatureShellModule),
    },
    {
        path: '**',
        loadChildren: () => import('@ho/pages/error/feature-shell').then((m) => m.ErrorFeatureShellModule),
    },
];
let AppModule = class AppModule {
    constructor() {
        document.body.classList.add('loading');
    }
};
AppModule.ctorParameters = () => [];
AppModule = __decorate([
    NgModule({
        declarations: [AppComponent],
        imports: [
            BrowserModule,
            BrowserAnimationsModule,
            HttpClientModule,
            RouterModule.forRoot(appRoutes, {
                useHash: false,
                scrollPositionRestoration: 'top',
                relativeLinkResolution: 'legacy',
            }),
            CoreDataAccessModule,
            ConfirmModalModule,
            ServiceWorkerModule.register('ngsw-worker.js', {
                enabled: environment.production,
                registrationStrategy: 'registerWithDelay:5000',
            }),
            DataAccessUiSettingsModule,
            TranslateModule.forRoot({
                loader: {
                    provide: TranslateLoader,
                    useFactory: TranslateLoaderFactory,
                    deps: [HttpClient, DOCUMENT],
                },
                isolate: false,
                missingTranslationHandler: { provide: MissingTranslationHandler, useClass: MissingTranslationService },
            }),
            GridStateAccessModule.forRoot(),
        ],
        providers: [
            { provide: AppEnvironment, useValue: environment },
            // { provide: ErrorHandler, useClass: SentryErrorHandler },
            deviceInitializerProvider,
            ServiceWorkerInitializerProvider,
            customAppConfigInitializerProvider,
            uiSettingsInitializerProvider,
            translationsInitializerProvider,
        ],
        bootstrap: [AppComponent],
    }),
    __metadata("design:paramtypes", [])
], AppModule);
export { AppModule };
